import React from "react";

function AboutPage() {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1>About Us</h1>
        <p>
          Meet the team behind Woolworth Software - a passionate group dedicated
          to delivering exceptional software solutions.
        </p>
      </div>

      <div className="team-grid">
        <div className="team-member">
          <div className="team-member-image">
            <img
              src="/website_images/bubba_01.JPEG"
              alt="Robert 'Bubba' Terp, Jr."
            />
          </div>
          <div className="team-member-info">
            <h2>Robert "Bubba" Terp, Jr.</h2>
            <h3>Founder & CEO</h3>
            <p>
              Robert is a dedicated husband and proud father of two beautiful
              children. When he's not crafting innovative software solutions,
              you'll find him spending quality time with his family and his two
              pups, Clover and Hazel. Robert believes that the same passion and
              care he brings to his family life translates into the work he does
              at Woolworth Software - building products that truly make a
              difference.
            </p>
            <p>
              With a deep commitment to both technical excellence and work-life
              balance, Robert founded Woolworth Software to create a company
              that values innovation, quality, and the people who make it all
              possible. Whether he's debugging code or playing board games with
              his family, Robert approaches every challenge with determination
              and dedication.
            </p>
          </div>
        </div>

        <div className="team-member">
          <div className="team-member-image">
            <img src="/website_images/clover.JPG" alt="Clover" />
          </div>
          <div className="team-member-info">
            <h2>Clover</h2>
            <h3>Senior Treat Consultant</h3>
            <p>
              Clover brings years of expertise in quality assurance - especially
              when it comes to ensuring all treats meet the highest standards.
              Her innovative approach to toy testing and her enthusiasm for
              team-building activities (especially those involving tennis balls)
              make her an invaluable member of the Woolworth Software family.
            </p>
          </div>
        </div>

        <div className="team-member">
          <div className="team-member-image">
            <img src="/website_images/hazel.JPG" alt="Hazel" />
          </div>
          <div className="team-member-info">
            <h2>Hazel</h2>
            <h3>Junior Treat Consultant</h3>
            <p>
              Hazel is an up-and-coming talent in the treat consulting division,
              bringing fresh perspectives and boundless energy to every project.
              With an impeccable sense for finding hidden snacks and an
              unwavering commitment to standing on top of people, Hazel keeps
              the team morale high and stress levels low.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
